import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import * as maplibregl from 'maplibre-gl';
import { SchedeService } from '../../../services/schede.service';
import { ComuniService } from '../../../services/comuni.service';
import { SchedaGeoJsonUtils, SchedeFeatureCollection } from '../../../models/scheda-geojson.model';
import { ComuniFeatureCollection } from '../../../models/comune-geojson.model';
import proj4 from 'proj4';
import { Scheda } from '../../../models/scheda.model';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-mappa-scheda-nuovo-intervento',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    TooltipModule
  ],
  providers: [DynamicDialogRef, DynamicDialogConfig],
  templateUrl: './mappa-scheda-nuovo-intervento.component.html',
  styleUrls: ['./mappa-scheda-nuovo-intervento.component.css']
})
export class MappaSchedaNuovoInterventoComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @ViewChild('map') mapContainer!: ElementRef;
  @Input() visible: boolean = false;
  @Input() titolo: string = 'Seleziona Scheda dalla Mappa';
  @Input() schede: Scheda[] = [];
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() schedaSelezionata = new EventEmitter<Scheda>();
  @Output() schedaSelezionataId = new EventEmitter<number>();
  private map: maplibregl.Map | null = null;
  private markers: maplibregl.Marker[] = [];
  private comuniData?: ComuniFeatureCollection;
  private mapInitialized = false;

  // Opzioni mappa
  opzioniMappa = {
    zoomScheda: true,
    mostraComuni: true,
    mostraPoints: true,
    mostraLines: true,
    mostraPolygons: true
  };

  constructor(
    private logger: NGXLogger,
    private messageService: MessageService,
    private schedeService: SchedeService,
    private comuniService: ComuniService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    if (this.config.data) {
      //this.schede = this.config.data.schede || [];
      this.visible = this.config.data.visible;
    }
  }

  ngOnInit(): void {
    //this.logger.info('[MAPPA-SCHEDA] ON INIT');
  }

  show(): void {
    this.visible = true;
    //this.logger.info('[MAPPA-SCHEDA] SHOW! Visible: ' + this.visible);
    this.initializeMapWithDelay();
    //this.enteId = localStorage.getItem("enteId") || '';
   // this.logger.info('[NUOVO INTERVENTO] SHOW! Ente ID: ' + this.enteId);

  }

  ngAfterViewInit(): void {
   /*  this.logger.info('[MAPPA-SCHEDA] AFTER VIEW INIT ' + this.visible);
    if (this.visible && !this.mapInitialized) {
      this.initializeMapWithDelay();
    } */
  }

  ngOnChanges(changes: SimpleChanges): void {
    /* if (changes['visible'] && changes['visible'].currentValue === true && !this.mapInitialized) {
      this.logger.info('[MAPPA-SCHEDA] VISIBLE CHANGED TO TRUE');
      this.initializeMapWithDelay();
    } */
  }

  private initializeMapWithDelay(): void {
    this.logger.info('[MAPPA-SCHEDA] INIT MAPPA WITH DELAY');
    // Aspettiamo che il dialog sia completamente renderizzato
    setTimeout(() => {
      if (this.mapContainer?.nativeElement) {
        this.initializeMap();
        this.mapInitialized = true;
      } else {
       /*  this.logger.error('[MAPPA-SCHEDA] Elemento mappa non trovato nel DOM, riprovo...');
        // Riprova dopo un breve delay
        setTimeout(() => {
          if (this.mapContainer?.nativeElement) {
            this.initializeMap();
            this.mapInitialized = true;
          } else {
            this.logger.error('[MAPPA-SCHEDA] Elemento mappa non trovato nel DOM dopo il secondo tentativo');
          }
        }, 500); */
      }
    }, 500);
  }

  onHide(): void {
    this.visibleChange.emit(false);
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  private caricaConfiniComuni(): void {
    this.comuniService.getConfiniComuni().subscribe({
      next: (data) => {
        this.comuniData = data;
        if (this.map && this.opzioniMappa.mostraComuni) {
          //this.aggiungiConfiniComuni();
        }
      },
      error: (error) => {
        this.logger.error('[MAPPA-SCHEDA] Errore nel caricamento dei confini comuni', error);
      }
    });
  }

   /**
   * Converte le coordinate da UTM a WGS84 (lon/lat) che MapLibre può visualizzare
   * @param geometry La geometria GeoJSON da convertire
   */
   private convertCoordinates(geometry: any): void {
    if (!geometry || !geometry.type) return;

    // Per Point
    if (geometry.type === 'Point' && Array.isArray(geometry.coordinates)) {
      geometry.coordinates = this.transformToWGS84(geometry.coordinates);
    }

    // Per LineString e MultiPoint
    else if ((geometry.type === 'LineString' || geometry.type === 'MultiPoint') &&
             Array.isArray(geometry.coordinates)) {
      geometry.coordinates = geometry.coordinates.map((coord: number[]) =>
        this.transformToWGS84(coord)
      );
    }

    // Per Polygon e MultiLineString
    else if ((geometry.type === 'Polygon' || geometry.type === 'MultiLineString') &&
             Array.isArray(geometry.coordinates)) {
      geometry.coordinates = geometry.coordinates.map((line: number[][]) =>
        line.map((coord: number[]) => this.transformToWGS84(coord))
      );
    }

    // Per MultiPolygon
    else if (geometry.type === 'MultiPolygon' && Array.isArray(geometry.coordinates)) {
      geometry.coordinates = geometry.coordinates.map((polygon: number[][][]) =>
        polygon.map((line: number[][]) =>
          line.map((coord: number[]) => this.transformToWGS84(coord))
        )
      );
    }

    // Per GeometryCollection
    else if (geometry.type === 'GeometryCollection' && Array.isArray(geometry.geometries)) {
      geometry.geometries.forEach((geom: any) => this.convertCoordinates(geom));
    }
  }

  /**
   * Trasforma una singola coordinata da UTM a WGS84
   * @param coord Coordinata [x, y] in UTM
   * @returns Coordinata [lon, lat] in WGS84
   */
  private transformToWGS84(coord: number[]): number[] {
    if (!coord || coord.length < 2) return coord;

    try {
      // Da EPSG:32632 (UTM Zona 32N) a WGS84 (EPSG:4326)
      // Modifica 'EPSG:32632' se il sistema di coordinate è diverso
      const wgs84Coord = proj4('EPSG:32632', 'EPSG:4326', [coord[0], coord[1]]);
      return wgs84Coord;
    } catch (error) {
      console.error('Errore durante la conversione delle coordinate:', error);
      return coord; // Restituisci le coordinate originali in caso di errore
    }
  }

  private caricaGeometrieSchede(): void {
    this.logger.info('[MAPPA-SCHEDA] Carico geometrie schede');
    this.schedeService.getGeometrieSchede().subscribe({
      next: (geometrie) => {
        //// this.logger.info('[SCHEDE] '+ (geometrie.features?.length || 0) + ' Geometrie schede recuperate con successo');

        try {
          // Configura proj4 per la conversione di coordinate
          proj4.defs('EPSG:32632', '+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs');

          // Converti le coordinate in tutte le geometrie
          if (geometrie.features && geometrie.features.length > 0) {
            geometrie.features.forEach(feature => {
              if (feature.geometry) {
                this.convertCoordinates(feature.geometry);
              }
            });
          }

          // Converti in una FeatureCollection valida
          const geoJsonFeatureCollection = SchedaGeoJsonUtils.toFeatureCollection(geometrie);

          // Separa le feature in base al tipo geometriaMarker
          const pointFeatures: SchedeFeatureCollection = {
            type: 'FeatureCollection',
            features: geoJsonFeatureCollection.features.filter(f =>
              (f.properties as any).geometriaMarker === 'point')
          };

          const lineFeatures: SchedeFeatureCollection = {
            type: 'FeatureCollection',
            features: geoJsonFeatureCollection.features.filter(f =>
              (f.properties as any).geometriaMarker === 'linestring')
          };

          const polygonFeatures: SchedeFeatureCollection = {
            type: 'FeatureCollection',
            features: geoJsonFeatureCollection.features.filter(f =>
              (f.properties as any).geometriaMarker === 'polygon')
          };

          // Standardizza le geometrie in base al loro tipo
          const standardizedPoints = pointFeatures.features.length > 0 ?
            SchedaGeoJsonUtils.standardizzaGeometrie(pointFeatures, 'point') : null;

          const standardizedLines = lineFeatures.features.length > 0 ?
            SchedaGeoJsonUtils.standardizzaGeometrie(lineFeatures, 'line') : null;

          const standardizedPolygons = polygonFeatures.features.length > 0 ?
            SchedaGeoJsonUtils.standardizzaGeometrie(polygonFeatures, 'polygon') : null;

          // Assegna i colori a tutte le geometrie
          [standardizedPoints, standardizedLines, standardizedPolygons]
            .filter(collection => collection !== null)
            .forEach(collection => {
              (collection!).features.forEach(feature => {
                (feature.properties as any).color = feature.properties.geometriaColore;
              });
            });

          // Aggiungi le geometrie alla mappa
          if (this.map) {
            // Rimuovi layer e source esistenti
            ['points-source', 'lines-source', 'polygons-source'].forEach(sourceId => {
              if ((this.map as any).getLayer(sourceId)) {
                (this.map as any).removeLayer(sourceId);
              }
              if ((this.map as any).getSource(sourceId)) {
                (this.map as any).removeSource(sourceId);
              }
            });

            // Aggiungi i point layer (marker)
            if (standardizedPoints && standardizedPoints.features.length > 0) {
              // Crea immagini per i marker speciali
              this.creaTriangoloMarker();
              this.creaAsteriskMarker();

              (this.map as any).addSource('points-source', {
                type: 'geojson',
                data: standardizedPoints
              });

              // Layer per i marker circolari (default)
              (this.map as any).addLayer({
                id: 'points-circle-source',
                type: 'circle',
                source: 'points-source',
                filter: [
                  'all',
                  ['!=', ['get', 'color'], '#33a02c'],
                  ['!=', ['get', 'oggettoInterventoCodice'], 'SG']
                ],
                paint: {
                  'circle-radius': 6,
                  'circle-color': ['get', 'color'],
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#ffffff'
                }
              });

              // Layer per i marker triangolari (per punti verdi)
              (this.map as any).addLayer({
                id: 'points-triangle-source',
                type: 'symbol',
                source: 'points-source',
                filter: [
                  'all',
                  ['==', ['get', 'color'], '#33a02c'],
                  ['!=', ['get', 'oggettoInterventoCodice'], 'SG']
                ],
                layout: {
                  'icon-image': 'triangle-marker',
                  'icon-size': 0.7,
                  'icon-allow-overlap': true
                }
              });

              // Layer per i marker a stella (per oggettoInterventoCodice = SG)
              (this.map as any).addLayer({
                id: 'points-star-source',
                type: 'symbol',
                source: 'points-source',
                filter: ['==', ['get', 'oggettoInterventoCodice'], 'SG'],
                layout: {
                  'icon-image': 'asterisk-marker',
                  'icon-size': 0.7,
                  'icon-allow-overlap': true,
                },
                paint: {
                  'icon-color': ['get', 'color']
                }
              });
            }

            // Aggiungi i linestring layer
            if (standardizedLines && standardizedLines.features.length > 0) {
              (this.map as any).addSource('lines-source', {
                type: 'geojson',
                data: standardizedLines
              });

              // Layer per le linestring normali (solide)
              (this.map as any).addLayer({
                id: 'lines-source',
                type: 'line',
                source: 'lines-source',
                filter: [
                  'all',
                  ['!=', ['get', 'oggettoInterventoCodice'], 'AV'],
                  ['!=', ['get', 'oggettoInterventoCodice'], 'AL']
                ],
                layout: {
                  'line-join': 'round',
                  'line-cap': 'round'
                },
                paint: {
                  'line-color': ['get', 'color'],
                  'line-width': 3,
                  'line-opacity': 1
                }
              });

              // Layer per le linestring tratteggiate (AV o AL)
              (this.map as any).addLayer({
                id: 'lines-dashed-source',
                type: 'line',
                source: 'lines-source',
                filter: [
                  'any',
                  ['==', ['get', 'oggettoInterventoCodice'], 'AV'],
                  ['==', ['get', 'oggettoInterventoCodice'], 'AL']
                ],
                layout: {
                  'line-join': 'round',
                  'line-cap': 'round'
                },
                paint: {
                  'line-color': ['get', 'color'],
                  'line-width': 3,
                  'line-opacity': 1,
                  'line-dasharray': [3, 2] // Pattern tratteggiato: 3px linea, 2px spazio
                }
              });
            }

            // Aggiungi i polygon layer
            if (standardizedPolygons && standardizedPolygons.features.length > 0) {
              (this.map as any).addSource('polygons-source', {
                type: 'geojson',
                data: standardizedPolygons
              });

              // Creo un canvas per generare il pattern di linee parallele
              this.creaPatternLineeDiagonali();

              // Aggiungi il contorno dei poligoni
              (this.map as any).addLayer({
                id: 'polygons-outline-source',
                type: 'line',
                source: 'polygons-source',
                paint: {
                  'line-color': ['get', 'color'],
                  'line-width': 2,
                  'line-opacity': 1
                }
              });

              // Aggiungi il riempimento dei poligoni con pattern a linee
              (this.map as any).addLayer({
                id: 'polygons-source',
                type: 'fill',
                source: 'polygons-source',
                paint: {
                  'fill-color': ['get', 'color'],
                  'fill-opacity': 0.8,  // Riduco l'opacità
                  'fill-pattern': 'diagonal-stripes'  // Uso il pattern creato
                }
              });
            }

            // Aggiungi interattività ai vari layer
            this.aggiungiInterattivitaGeometrie();
            this.zoomSuComune();

            // Evento di caricamento e aggiunta confini comuni
            /* this.map.on('sourcedata', (e: any) => {
              const sourceIds = ['points-source', 'lines-source', 'polygons-source'];
              if (sourceIds.includes(e.sourceId) && this.map && (this.map as any).getSource(e.sourceId)) {
                if ((this.map as any).isSourceLoaded(e.sourceId)) {
                  // Dopo che le geometrie delle schede sono caricate, aggiungi i confini dei comuni
                  this.aggiungiConfiniComuni();
                }
              }
            }); */

          } else {
            this.logger.error('[SCHEDE] Mappa non inizializzata');
          }
        } catch (error) {
          this.logger.error('[SCHEDE] Errore nella conversione dei dati GeoJSON:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Errore dati',
            detail: 'Errore durante l\'elaborazione delle geometrie: ' + (error as Error).message,
            life: 5000
          });

          // Aggiungi un marcatore al centro della mappa come fallback
          //this.aggiungiMarkereCentrale();
        }
      },
      error: (error) => {
        this.logger.error('[SCHEDE] Errore nel recupero delle geometrie delle schede:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore di connessione',
          detail: 'Impossibile recuperare le geometrie delle schede',
          life: 5000
        });

        // Aggiungi un marcatore al centro della mappa come fallback
      // this.aggiungiMarkereCentrale();
      }
    });
  }

  private creaPatternLineeDiagonali(): void {
    if (!this.map) return;

    // Dimensioni del pattern
    const size = 10;
    const lineWidth = 1;
    const spacing = 4;

    // Crea un elemento canvas
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Pulisci il canvas
    ctx.clearRect(0, 0, size, size);

    // Imposta il colore di sfondo trasparente
    ctx.fillStyle = 'rgba(0, 0, 0, 0)';
    ctx.fillRect(0, 0, size, size);

    // Imposta lo stile della linea
    ctx.strokeStyle = 'rgba(128, 128, 128, 0.5)'; // Grigio semi-trasparente
    ctx.lineWidth = lineWidth;

    // Disegna linee diagonali parallele
    for (let i = -size; i < size * 2; i += spacing) {
      ctx.beginPath();
      ctx.moveTo(i, 0);
      ctx.lineTo(i + size, size);
      ctx.stroke();
    }

    // Converti il canvas in un'immagine e aggiungila alla mappa
    const imageData = canvas.toDataURL();
    const img = new Image();
    img.onload = () => {
      // Quando l'immagine è caricata, aggiungila alla mappa
      (this.map as any).addImage('diagonal-stripes', img, { sdf: false });
    };
    img.src = imageData;
  }

  private aggiungiInterattivitaGeometrie(): void {
    if (!this.map) return;

    // Crea un elemento div per il tooltip
    const tooltipEl = document.createElement('div');
    tooltipEl.className = 'maplibre-tooltip';
    tooltipEl.style.display = 'none';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.backgroundColor = 'white';
    tooltipEl.style.padding = '6px 10px';
    tooltipEl.style.borderRadius = '4px';
    tooltipEl.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
    tooltipEl.style.fontSize = '12px';
    tooltipEl.style.pointerEvents = 'none'; // Consente l'interazione con ciò che c'è sotto
    tooltipEl.style.zIndex = '1000';
    tooltipEl.innerHTML = 'Tooltip';

    // Aggiungi il tooltip al container della mappa
    const mapContainer = (this.map as any).getContainer();
    mapContainer.appendChild(tooltipEl);

    // Layer IDs da monitorare per l'interattività
    const layerIds = ['points-circle-source', 'points-triangle-source', 'points-star-source', 'lines-source', 'lines-dashed-source', 'polygons-source', 'polygons-outline-source'];

    // Gestisci il mousemove per mostrare il tooltip
    layerIds.forEach(layerId => {
      (this.map as any).on('mousemove', layerId, (e: any) => {
        if (!this.map || !e.features || e.features.length === 0) return;

        // Imposta il cursore a pointer
        (this.map as any).getCanvas().style.cursor = 'pointer';

        // Estrai informazioni dalla feature
        const feature = e.features[0];
        const codice = feature.properties.codice || '';
        const vecchioCodice = feature.properties.vecchioCodiceUmvs || '';
        // Aggiorna il contenuto del tooltip
        tooltipEl.innerHTML = `
          <strong>${codice}</strong>

        `;
  /*  <div>${vecchioCodice}</div> */
        // Posiziona il tooltip vicino al cursore
        tooltipEl.style.left = `${e.point.x + 10}px`;
        tooltipEl.style.top = `${e.point.y - 20}px`;

        // Mostra il tooltip
        tooltipEl.style.display = 'block';
      });

      // Nascondi il tooltip quando il mouse esce dalla geometria
      (this.map as any).on('mouseleave', layerId, () => {
        if (!this.map) return;

        // Ripristina il cursore
        (this.map as any).getCanvas().style.cursor = '';

        // Nascondi il tooltip
        tooltipEl.style.display = 'none';
      });

      // Gestisci il click per mostrare il popup
      (this.map as any).on('click', layerId, (e: any) => {
        if (!this.map || !e.features || e.features.length === 0) return;

        // Estrai informazioni dalla feature
        const feature = e.features[0];
        // this.logger.info('[SCHEDE] Feature:', feature);
        const titolo = feature.properties.titolo || 'Scheda senza titolo';
        const codice = feature.properties.codice || '';
        const codiceATO = feature.properties.nuovoCodiceAto || '';
        const color = feature.properties.color || '#000000';
        const vecchioCodice = feature.properties.vecchioCodiceUmvs || '';
        const oggettoIntervento = feature.properties.oggettoInterventoCodice || '';
        // Ottieni le coordinate del click
        const coordinates = e.lngLat;

        // Crea popup con informazioni
        new maplibregl.Popup({
          closeButton: true,
          closeOnClick: true,
          maxWidth: '300px'
        })
        .setLngLat(coordinates)
        .setHTML(`
          <div class="popup-content">
            <h4 style="color: ${color}; margin: 0 0 10px 0; border-bottom: 1px solid #eee; padding-bottom: 5px;">${codice}</h4>
            <p style="margin: 0; font-size: 13px;"><strong>VecchioCodice:</strong> ${vecchioCodice}</p>
            <p style="margin: 5px 0 0 0; font-size: 13px;"><strong>Oggetto Intervento:</strong> ${oggettoIntervento}</p>
            <p style="margin: 5px 0 0 0; font-size: 13px;"><strong>Codice ATO:</strong> ${codiceATO}</p>
            ${feature.properties.bacinoNome ? `<p style="margin: 5px 0 0 0; font-size: 13px;"><strong>Bacino:</strong> ${feature.properties.bacinoNome}</p>` : ''}
            ${feature.properties.comuneNome ? `<p style="margin: 5px 0 0 0; font-size: 13px;"><strong>Comune:</strong> ${feature.properties.comuneNome}</p>` : ''}
            <div style="margin-top: 15px; text-align: center;">
              <button id="seleziona-scheda-${feature.properties.id}"
                      style="background-color: #33a02c; color: white; border: none; padding: 5px 10px;
                             border-radius: 4px; cursor: pointer; font-size: 12px; font-weight: bold;"
                             >
                SELEZIONA
              </button>
            </div>
          </div>
        `)
        .addTo(this.map as any);
        setTimeout(() => {
          const btn = document.getElementById(`seleziona-scheda-${feature.properties.id}`);
          if (btn) {
            btn.addEventListener('click', () => {
              console.log('[MAPPA-SCHEDA] Pulsante selezione cliccato per la scheda:', feature.properties.id);
              this.selezionaScheda(feature.properties.id);
            });
          }
        }, 0);

      });
    });
  }

  selezionaScheda(id: any): void {

    this.visibleChange.emit(false);
    this.schedaSelezionataId.emit(id);
    this.visible = false;
   // this.onHide();
    /* let scheda: Scheda = this.schede.find(s => s.id === id) as Scheda;
    if (scheda) {
      this.logger.info('[MAPPA-SCHEDA] Seleziona scheda: ' + id);

      this.schedaSelezionata.emit(scheda);

    } */

  }

  private creaTriangoloMarker(): void {
    if (!this.map) return;

    // Dimensioni dell'immagine
    const size = 24;

    // Crea un elemento canvas
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Pulisci il canvas
    ctx.clearRect(0, 0, size, size);

    // Disegna il triangolo
    ctx.beginPath();
    ctx.moveTo(size/2, 0);          // Vertice in alto
    ctx.lineTo(size, size);         // Vertice in basso a destra
    ctx.lineTo(0, size);            // Vertice in basso a sinistra
    ctx.closePath();

    // Riempimento verde (#33a02c)
    ctx.fillStyle = '#33a02c';
    ctx.fill();

    // Bordo bianco
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 2;
    ctx.stroke();

    // Converti in immagine e aggiungi alla mappa
    const imageData = canvas.toDataURL();
    const img = new Image();
    img.onload = () => {
      (this.map as any).addImage('triangle-marker', img, { sdf: false });
    };
    img.src = imageData;
  }

  /**
   * Crea un'immagine a forma di asterisco da utilizzare come marker
   */
  private creaAsteriskMarker(): void {
    if (!this.map) return;

    // Dimensioni dell'immagine
    const size = 24;
    const centerX = size / 2;
    const centerY = size / 2;
    const radius = size / 2 - 2; // Lascia un po' di margine

    // Crea un elemento canvas
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Pulisci il canvas
    ctx.clearRect(0, 0, size, size);

    // Imposta lo stile per l'asterisco
    // Usa il bianco per l'immagine SDF che verrà colorata dinamicamente
    ctx.lineWidth = 3;
    ctx.strokeStyle = 'white';

    // Disegna le linee dell'asterisco (6 linee per creare un asterisco a 6 punte)
    const angles = 6;
    for (let i = 0; i < angles; i++) {
      const angle = (Math.PI / angles) * i;

      ctx.beginPath();
      // Linea dal centro verso l'esterno
      ctx.moveTo(centerX, centerY);
      ctx.lineTo(
        centerX + radius * Math.cos(angle),
        centerY + radius * Math.sin(angle)
      );
      ctx.stroke();
    }

    // Aggiungi un cerchio al centro per migliorare l'aspetto
    ctx.beginPath();
    ctx.arc(centerX, centerY, 2, 0, Math.PI * 2);
    ctx.fillStyle = 'white';
    ctx.fill();

    // Converti in immagine e aggiungi alla mappa come SDF
    const imageData = canvas.toDataURL();
    const img = new Image();
    img.onload = () => {
      // Imposta sdf: true per permettere la colorazione
      (this.map as any).addImage('asterisk-marker', img, { sdf: true });
    };
    img.src = imageData;
  }

  private initializeMap(): void {
    this.logger.info('[MAPPA-SCHEDA] INIT MAPPA');

    if (!this.mapContainer || !this.mapContainer.nativeElement) {
      this.logger.error('[MAPPA-SCHEDA] Elemento mappa non trovato nel DOM');
      return;
    }
    try {
      const initialState = {
        lng: 7.200,
        lat: 45.1381,
        zoom: 9.8
      };

      this.map = new maplibregl.Map({
        container: this.mapContainer.nativeElement,
        style: {
          version: 8 as 8,
          sources: {
            'osm-tiles': {
              type: 'raster',
              tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
              tileSize: 256
            }
          },
          layers: [
            {
              id: 'osm-tiles',
              type: 'raster',
              source: 'osm-tiles',
              minzoom: 0,
              maxzoom: 19
            }
          ]
        },
        center: [initialState.lng, initialState.lat],
        zoom: initialState.zoom
      });

      (this.map as any).addControl(new maplibregl.NavigationControl(), 'top-right');
      //(this.map as any).addControl(new maplibregl.ScaleControl(), 'bottom-left');

      this.map.on('load', () => {
        this.caricaGeometrieSchede();
        //this.zoomSuComune();

      });
    } catch (error) {
      this.logger.error('[MAPPA-SCHEDA] Errore durante l\'inizializzazione della mappa:', error);
    }
  }

  public zoomSuComune(): void {


    try {
      // Calcola il bounding box di tutte le geometrie
      const bounds = new maplibregl.LngLatBounds();
      // Aggiungi tutte le coordinate al bounding box
      bounds.extend([parseFloat(localStorage.getItem("longitudineComune") || '0'), parseFloat(localStorage.getItem("latitudineComune") || '0')]);
      this.logger.info('[MAPPA-SCHEDA] zoomSuComune:', localStorage.getItem("longitudineComune") + ' ' + localStorage.getItem("latitudineComune") );
      // Se il bounds non è vuoto, zooma su di esso
      if (!bounds.isEmpty()) {
        (this.map as any).fitBounds(bounds, {
          padding: 10,
          maxZoom: 11
        });
      }
    } catch (error) {
      this.logger.error('[MAPPA-SCHEDA] Errore nel calcolo del bounding box:', error);
    }
  }


  private elaboraEVisualizzaDati(geometrie: any): void {
   /*  if (!this.map) return;

    const standardizedData = SchedaGeoJsonUtils.standardizeGeoJSON(geometrie);

    if (this.opzioniMappa.mostraPoints) {
      this.aggiungiPointLayers(standardizedData);
    }
    if (this.opzioniMappa.mostraLines) {
      this.aggiungiLineLayers(standardizedData);
    }
    if (this.opzioniMappa.mostraPolygons) {
      this.aggiungiPolygonLayers(standardizedData);
    }

    this.aggiungiInterattivitaGeometrie();
  }

  private aggiungiInterattivitaGeometrie(): void {
    if (!this.map) return;

    const layerIds = ['points-layer', 'lines-layer', 'polygons-layer'];

    layerIds.forEach(layerId => {
      if (this.map?.getLayer(layerId)) {
        this.map.on('click', layerId, (e) => {
          if (e.features && e.features.length > 0) {
            const properties = e.features[0].properties;
            this.apriDettagliScheda(properties);
          }
        });

        this.map.on('mouseenter', layerId, () => {
          if (this.map) {
            this.map.getCanvas().style.cursor = 'pointer';
          }
        });

        this.map.on('mouseleave', layerId, () => {
          if (this.map) {
            this.map.getCanvas().style.cursor = '';
          }
        });
      }
    }); */
  }

  private apriDettagliScheda(properties: any): void {
    const scheda = this.schede.find(s => s.id === properties.id);
    if (scheda) {
      this.schedaSelezionata.emit(scheda);
      this.visibleChange.emit(false);
    }
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }
}
